import type { JSX } from 'react';
import { LegalPage } from './LegalPage';

export function Compliance(): JSX.Element {
  return <LegalPage slug="compliance" />;
}

export default Compliance;
